import { type CSSProperties, type PropsWithChildren } from 'react'
import { ThemeProvider, type Theme } from '@dhl/theme'

const getThemeOverrides = (theme: Theme): Partial<Theme> => ({
  components: {
    ...theme.components,
    MuiAppBar: {
      ...theme.components?.MuiAppBar,
      styleOverrides: {
        ...theme.components?.MuiAppBar?.styleOverrides,
        root: {
          [theme.breakpoints.up('sm')]: {
            background: 'transparent',
          },
          [theme.breakpoints.down('sm')]: {
            background: `linear-gradient(180deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.main} 75%, rgba(255,204,0,0) 100%)`,
          },
        },
      },
    },
    MuiCssBaseline: {
      ...theme.components?.MuiCssBaseline,
      styleOverrides: {
        ...(theme.components?.MuiCssBaseline?.styleOverrides as CSSProperties),
        body: {
          [theme.breakpoints.down('sm')]: {
            backgroundColor: theme.palette.secondary.main,
            background: `linear-gradient(180deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.main} 30%, #FFE57F 79%, #FFF0B2 100%)`,
          },
        },
      },
    },
    MuiDivider: {
      ...theme.components?.MuiDivider,
      styleOverrides: {
        ...theme.components?.MuiDivider?.styleOverrides,
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.23)',
          border: 0,
          height: 1,
        },
      },
    },
    MuiPaper: {
      ...theme.components?.MuiPaper,
      styleOverrides: {
        ...theme.components?.MuiPaper?.styleOverrides,
        root: {
          border: 0,
        },
      },
    },
    MuiStack: {
      defaultProps: {
        // using the non-flexbox implementation sets a margin-top on all child elements of the stack,
        // which sometimes causes problems with for example the backdrop of the swipe dialog
        useFlexGap: true,
      },
    },
  },
})

const mergeThemeWithOverrides = (theme: Theme): Theme =>
  ({
    ...theme,
    ...getThemeOverrides(theme),
  }) as Theme

export const ThemeOverride = ({ children }: PropsWithChildren) => (
  <ThemeProvider theme={mergeThemeWithOverrides}>{children}</ThemeProvider>
)
